export class OperationHour {
    SelectedDaysWeek: any[] = [];

    SelectStartTime: Date | null = null;

    SelectStartTimeIsEmpty: boolean = false;

    SelectEndTime: Date | null = null;

    SelectEndTimeIsEmpty: boolean = false;
}
